import { I18n } from '@calendly/i18n'
import { useDropdown } from '@calendly/ui/components/dropdown'
import {
  VideoIcon,
  PhoneIcon,
  LocationPinIcon,
  ArrowChevronDownMiniIcon,
  ArrowChevronUpMiniIcon
} from '@calendly/ui/components/icons'

import { getLabelForKind } from '../utils'
import { Label } from './label'
import { LocationOptionList } from './location_option_list'
import {
  Container,
  StyledBareButtonWrapper,
  StyledBareButton,
  AllOptionsWrapper,
} from './styles'

const getLocationButtons = (shouldDisableOutbound) => [
  {
    kind: 'zoom_conference',
    icon: <VideoIcon size="standard" />,
  },
  {
    kind: shouldDisableOutbound ? 'inbound_call' : 'outbound_call',
    icon: <PhoneIcon size="standard" />,
  },
  {
    kind: 'physical',
    icon: <LocationPinIcon size="standard" />,
  },
]

const SquareLocationButton = ({ onClickAction, icon, kind }) => (
  <StyledBareButtonWrapper>
    <StyledBareButton aria-label={getLabelForKind(kind)} onClick={onClickAction}>
      <Label icon={icon} kind={kind} />
    </StyledBareButton>
  </StyledBareButtonWrapper>
)

const SquareAllOptionsButton = ({
  kind,
  onSelect,
  availableKinds
}) => {
  const [toggleAllOptionsDropdown, AllOptionsDropdown, isOpen] = useDropdown()

  return (
    <AllOptionsWrapper isOpen={isOpen}>
      <StyledBareButton
        aria-label={I18n.t('publisher.event_types.additional_options')}
        onClick={toggleAllOptionsDropdown}
      >
        <Label icon={isOpen ? <ArrowChevronUpMiniIcon size="standard" /> : <ArrowChevronDownMiniIcon size="standard" />} kind={kind} />
      </StyledBareButton>
      <AllOptionsDropdown>
        <LocationOptionList
          updateSelectedKind={onSelect}
          availableKinds={availableKinds}
        />
      </AllOptionsDropdown>
    </AllOptionsWrapper>
  )
}

export const LocationSelectButtons = ({
  onChange,
  availableKinds,
  shouldDisableOutbound
}) => {
  const locationButtons = getLocationButtons(shouldDisableOutbound)
  const kindsFiltered = availableKinds.filter(
    ({ type, value }) => type !== 'divider' && !locationButtons.some((btn) => btn.kind === value)
  ).map(({ value }) => value)

  return (
    <Container data-calendly-label="event-details-location">
      {locationButtons.map(({ kind, icon }) => (
        <SquareLocationButton
          key={kind}
          icon={icon}
          kind={kind}
          onClickAction={() => onChange(kind)}
        />
      ))}
      <SquareAllOptionsButton
        kind="all_options"
        onSelect={onChange}
        availableKinds={kindsFiltered}
      />
    </Container>
  )
}
